import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { authService } from '../services/authService';

const GoogleSignIn = ({ onSuccess, onError }) => {
  const handleSuccess = async (credentialResponse) => {
    try {
      const result = await authService.googleSignIn(credentialResponse.credential);
      if (onSuccess) {
        onSuccess(result);
      }
    } catch (error) {
      console.error('Google sign-in failed:', error);
      if (onError) {
        onError(error);
      }
    }
  };

  const handleError = (error) => {
    console.error('Google sign-in error:', error);
    if (onError) {
      onError(error);
    }
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '20px',
      padding: '20px',
      border: '1px solid #ddd',
      borderRadius: '8px',
      backgroundColor: '#f9f9f9'
    }}>
      <h3>Sign in to AI CardioMeter</h3>
      <p style={{ textAlign: 'center', color: '#666' }}>
        Please sign in with your Google account to access the application
      </p>
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        theme="outline"
        size="large"
        text="signin_with"
        shape="rectangular"
      />
    </div>
  );
};

export default GoogleSignIn;